import moment from "moment";

export const DateFormats = {
  //These are moment specific date formats. reference https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/
  DD_MMMM_YYYY: "DD MMMM YYYY", //11 January 2020
  YYYY_MM_DD: "YYYY-MM-DD ", // 2020-01-11
  YYYY_MM_DD__HH_mm_ss_SSS: "YYYY-MM-DD HH:mm:ss.SSS",// 2019-12-17 12:39:52.380
  YYYYMMDD_HHmmss_SSS: "YYYYMMDD_HHmmss_SSS",// 20191217_123952_380
};

export default {
  getFormatDateAsString(dateString, fromDateFormat, toDateFormat) {
    return moment(dateString, fromDateFormat).format(toDateFormat);
  },

  getCurrentTimeAsFormat(format) {
    return moment().format(format);
  }
};
